import { render } from "./header-before-sti-dest.vue?vue&type=template&id=4fa08670&scoped=true&ts=true"
import script from "./header-before-sti-dest.vue?vue&type=script&lang=ts"
export * from "./header-before-sti-dest.vue?vue&type=script&lang=ts"

import "./header-before-sti-dest.vue?vue&type=style&index=0&id=4fa08670&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa08670"]])

export default __exports__